import { useState, useEffect } from 'react';
import { translations, Language } from '../data/translations';

interface LocationState {
  currency: string;
  countryCode: string;
  loading: boolean;
}

export function useLocalization() {
  const [lang, setLang] = useState<Language>('en');
  const [location, setLocation] = useState<LocationState>({
    currency: '$',
    countryCode: 'US',
    loading: true
  });

  useEffect(() => {
    // 1. Fetch IP Data
    fetch('https://ipapi.co/json/')
      .then(res => res.json())
      .then(data => {
        if (data.currency) {
          setLocation({
            currency: getCurrencySymbol(data.currency),
            countryCode: data.country_code,
            loading: false
          });
          
          // 2. Auto-detect Language based on country? 
          // For now, we'll keep English default unless it's explicitly an Arab/French/Spanish country
          // This logic can be expanded.
          if (['SA', 'AE', 'EG', 'KW', 'QA', 'OM', 'BH', 'JO', 'LB'].includes(data.country_code)) setLang('ar');
          else if (['FR', 'MA', 'DZ', 'TN', 'SN'].includes(data.country_code)) setLang('fr');
          else if (['ES', 'MX', 'AR', 'CO'].includes(data.country_code)) setLang('es');
          else if (['PK'].includes(data.country_code)) setLang('ur');
        }
      })
      .catch(() => {
        // Silent fail or minimal log to avoid noise
        console.warn("Localization fetch skipped or failed, using defaults.");
        setLocation(prev => ({ ...prev, loading: false }));
      });
  }, []);

  const t = translations[lang];
  const isRTL = lang === 'ar' || lang === 'ur';

  return { 
    lang, 
    setLang, 
    currency: location.currency, 
    t,
    isRTL
  };
}

function getCurrencySymbol(code: string): string {
  try {
    return (0).toLocaleString(undefined, { style: 'currency', currency: code }).replace(/\d|\s/g, '');
  } catch {
    return code; 
  }
}
